import { lighten } from 'polished';
import { keyframes, css } from 'styled-components';
export var shimmer = keyframes(["0%{opacity:0.5;}50%{opacity:1;}100%{opacity:0.5;}"]);
export var wave = keyframes(["0%{transform:translate3d(-100%,0,0);}100%{transform:translate3d(100%,0,0);}"]); // The same everywhere, from what I can see.

var ANIMATION_DELAY = '0.2s';
export var makeSkeletonShape = function makeSkeletonShape(_ref) {
  var shape = _ref.shape,
      theme = _ref.theme;

  if (shape === 'squircle') {
    return css(["clip-path:url(#svgPath);"]);
  }

  return css(["border-radius:", ";"], shape === 'circle' ? '50%' : shape === 'squareRounded' ? theme.radii[16] : undefined);
};
export var makeSkeletonAnimation = function makeSkeletonAnimation(_ref2) {
  var animation = _ref2.animation,
      animationDelay = _ref2.animationDelay;
  return css(["animation:", " 1.5s ease-in-out infinite;animation-delay:", ";&:after{display:", ";content:'';position:absolute;top:0;left:0;width:100%;height:100%;animation:", " 1.5s ease-in-out infinite;animation-delay:", ";background-image:", ";}"], animation === 'shimmer' ? shimmer : 'none', animation === 'shimmer' && animationDelay ? ANIMATION_DELAY : undefined, animation === 'wave' ? 'block' : 'none', animation === 'wave' ? wave : 'none', animation === 'wave' && animationDelay ? ANIMATION_DELAY : undefined, function (_ref3) {
    var theme = _ref3.theme;
    return "linear-gradient(90deg,\n        " + theme.colors.grey.light + ",\n        " + lighten(0.04, theme.colors.grey.light) + ",\n        " + theme.colors.grey.light + "\n      )";
  });
}; // Props that should not be forwarded to the HTML DOM elements

export var shouldForwardProp = function shouldForwardProp(prop, defaultValidationFn) {
  return !['shape'].includes(prop) && defaultValidationFn(prop);
};